"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OrderOnBehalfDialog = require("./OrderOnBehalfDialog");
Object.keys(_OrderOnBehalfDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OrderOnBehalfDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OrderOnBehalfDialog[key];
    }
  });
});
var _ChangeConsultantForm = require("./ChangeConsultantForm");
Object.keys(_ChangeConsultantForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangeConsultantForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChangeConsultantForm[key];
    }
  });
});
